var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.qrUrl != 'iniciado' && _vm.qrUrl != '' && !_vm.activo)?_c('v-container',{attrs:{"lighten-5":""}},[_c('v-img',{attrs:{"src":_vm.qrUrl,"width":"400","height":"400"}})],1):_vm._e(),(_vm.activo)?_c('v-container',{attrs:{"lighten-5":""}},[_vm._v(" chatbot activo ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }